// extracted by mini-css-extract-plugin
module.exports = {"footer":"ContentsListFooter_footer__F_2HP","content":"ContentsListFooter_content__3_Pkz"};